import { render, staticRenderFns } from "./NumberInfo.vue?vue&type=template&id=33b2ad93&scoped=true&"
import script from "./NumberInfo.vue?vue&type=script&lang=js&"
export * from "./NumberInfo.vue?vue&type=script&lang=js&"
import style0 from "./NumberInfo.vue?vue&type=style&index=0&id=33b2ad93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2ad93",
  null
  
)

export default component.exports